import { Component, Inject } from '@angular/core';
import { ConfirmDialogModel } from '../../models/confirm-dialog.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EnableEscCloseDirective } from '../../directives/enable-esc-close.directive';
import { UiButtonComponent } from '../ui-button/ui-button.component';
import { TranslatePipe } from '@ngx-translate/core';


@Component({
  selector: 'ui-confirm-dialog',
  templateUrl: './ui-confirm-dialog.component.html',
  styleUrls: ['./ui-confirm-dialog.component.scss'],
  standalone: true,
  hostDirectives: [EnableEscCloseDirective],
  imports: [UiButtonComponent, TranslatePipe],
})
export class UiConfirmDialogComponent {
  public ConfirmDialogSelection: typeof ConfirmDialogModel.ConfirmResult =
    ConfirmDialogModel.ConfirmResult;
  public ConfirmDialogType: typeof ConfirmDialogModel.ConfirmDialogType =
    ConfirmDialogModel.ConfirmDialogType;

  constructor(
    private dialogRef: MatDialogRef<
      UiConfirmDialogComponent,
      ConfirmDialogModel.ConfirmDialogResult
    >,
    @Inject(MAT_DIALOG_DATA)
    public options: ConfirmDialogModel.ConfirmDialogOptions,
  ) {}

  public close(selection: ConfirmDialogModel.ConfirmResult): void {
    this.dialogRef.close({ selection, type: this.options.type });
  }
}
